export const ROUTES = {
  home: "/",
  projects: "/projects",
};
